module.exports = __webpack_public_path__ + "img/3_diamonds_star.52308175.png";